/**
 * Intent constants for drug/allergy interaction flows.
 * Use these for case-insensitive comparison with API intent values.
 */

export const INTENT_HIGH_SEVERITY = "high_severity";
export const INTENT_MODERATE_AND_MINOR_SEVERITY = "moderate_and_minor_severity";
export const INTENT_VIEW_INTERACTIONS = "view_interactions";
